import { Box } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { DateTime } from 'luxon';

import { TimestampCountdownProps } from './TimestampCountdown.props';
import { getCountdownToExpiry } from './getCountdownToExpiry';

export const TimestampCountdown = ({
  maxDelay,
  onExpire,
  timestamp,
  timeZone,
  children,
}: TimestampCountdownProps) => {
  const [currentDate, setCurrentDate] = useState<DateTime>(DateTime.now());
  const [onExpireCalled, setOnExpireCalled] = useState<boolean>(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDate(DateTime.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timestamp) {
      const dateTime = DateTime.fromMillis(timestamp.toMillis());

      if (!onExpireCalled && onExpire && dateTime < currentDate) {
        onExpire();
        setOnExpireCalled(true);
      }
    }
  }, [currentDate, onExpire, onExpireCalled, timestamp]);

  const countdown = useMemo(() => {
    if (!timestamp || !timeZone) {
      return null;
    }
    // The backend already freezes the expiry over weekends and holidays, so the
    // countdown is simply the time remaining until that expiry.
    return getCountdownToExpiry(timestamp.toMillis(), currentDate.toMillis());
  }, [timestamp, timeZone, currentDate]);

  if (
    !timestamp ||
    !timeZone ||
    DateTime.fromMillis(timestamp.toMillis()) < currentDate
  ) {
    return null;
  }

  return (
    <>
      <Box>{countdown?.toFormat('hh:mm')}</Box>
      {countdown && countdown?.hours < maxDelay ? children : null}
    </>
  );
};
